module.exports = __webpack_public_path__ + "img/Group 4097.dd1b5ada.png";